package one.healthium.insights.ui.insights.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.ui.NetworkImage
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun SavedContentItem(
    modifier: Modifier = Modifier,
    model: SavedContentModel,
    onClick: (SavedContentModel) -> Unit,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        onClick = { onClick(model) },
        color = white,
        shape = AppTheme.shapes.small,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(12.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (model.content.thumbUrl != null) {
                NetworkImage(
                    imageUrl = model.content.thumbUrl,
                    modifier = Modifier.size(71.dp),
                    contentScale = ContentScale.Crop,
                )
                Spacer(Modifier.width(10.dp))
            }
            Column(
                modifier = Modifier.weight(1f)
            ) {
                if (!model.content.title.isNullOrEmpty()) {
                    Text(
                        text = model.content.title,
                        style = AppTheme.textStyles.secondary_16_500,
                        color = AppTheme.colors.text100,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                    )
                    Spacer(Modifier.height(6.dp))
                }
                if (!model.content.description.isNullOrEmpty()) {
                    Text(
                        text = model.content.description,
                        style = AppTheme.textStyles.secondary_14_400,
                        color = AppTheme.colors.text300,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
            Spacer(Modifier.width(8.dp))
            Image(
                painter = painterResource(AppIcons.icArrowRight),
                contentDescription = null,
            )
        }
    }
}